import { Discount } from '@/modules/marketplace/discounts/types/Discount.ts'

export interface DiscountState {
  isCreateModalOpen: boolean
  // There is no endpoint to get a discount by id: the row itself is edited
  editDiscount: Discount | null
  filters: string
}

export const initialState: DiscountState = {
  isCreateModalOpen: false,
  editDiscount: null,
  filters: ''
}
